const doc = [({"da":({"js":({"users":({"confirmation":({"new":({"the_confirmation_email_was_sent_again":"Email til bekræftelse er blevet sendt igen."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;